import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { Text } from '../typography/Text';
import { CheckboxButton } from '../checkbox/CheckboxButton';
import { CheckStatus } from '../virtual-data/VirtualData';
import { BaseProps, CheckableType } from '../common/props';
import { formatNumber } from '@mc/react-format';
import { InverseBgProvider } from '../theme/InverseBg';

type Props = BaseProps & {
  checkable?: CheckableType;
  disabled?: boolean;
  inverse?: boolean;
  checkedStatus?: CheckStatus;
  onToggleCheckAll?: () => void;
  /**
   * Extra, zobrazené na konci headeru, vlevo od celkového počtu položek.
   */
  extraRight?: React.ReactNode;
  totalElements?: number;
};

export const ListHeader = ({
  checkable,
  disabled,
  className,
  style,
  children,
  checkedStatus,
  onToggleCheckAll,
  extraRight,
  totalElements,
  inverse,
}: Props) => {
  const showCheckSymbol = checkable === true;

  return (
    <InverseBgProvider inverse={inverse}>
      <div
        className={classNames(Classes.LIST_HEADER, className, {
          [Classes.LIST_HEADER_INVERSE]: inverse,
          [Classes.LIST_HEADER_NOT_CHECKABLE]: !showCheckSymbol,
        })}
        style={style}
      >
        {showCheckSymbol && (
          <div className={Classes.LIST_HEADER_CHECK}>
            <CheckboxButton
              disabled={disabled || totalElements === 0}
              // @ts-ignore
              onChange={() => onToggleCheckAll?.()}
              indeterminate={checkedStatus === CheckStatus.SOME_CHECKED}
              checked={
                checkedStatus === CheckStatus.ALL_CHECKED
                  ? true
                  : checkedStatus === CheckStatus.ALL_UNCHECKED
                    ? false
                    : undefined
              }
            />
          </div>
        )}
        <div className={Classes.LIST_HEADER_CONTENT}>{children}</div>
        <div className={Classes.LIST_HEADER_RIGHT}>
          {extraRight ?? null}
          {totalElements !== undefined && (
            <div className={'ml-1'}>
              Počet záznamů: <Text strong>{formatNumber(totalElements)}</Text>
            </div>
          )}
        </div>
      </div>
    </InverseBgProvider>
  );
};
